// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Op4","colBig":"styles_colBig__YcmOB","colSmall":"styles_colSmall__29W_t"};